module.exports = __webpack_public_path__ + "img/play_video.e1da21c1.png";